import { useState } from 'react';
import { TextEditorHandler } from '../handlers/textEditorHandler';

const textEditorHandler = TextEditorHandler.instance;

export default function useLastSavedAt(editorStateLocalStorageKey: string) {
  const lastSavedAtState = useState<Date | null>(() => {
    const lastSavedAt = textEditorHandler.getEditorStateFromLocalStorage(
      editorStateLocalStorageKey,
    )?.lastSavedAt;

    if (lastSavedAt) return new Date(lastSavedAt);

    return null;
  });

  return lastSavedAtState;
}
